import { render, staticRenderFns } from "./shiftManagementMain.vue?vue&type=template&id=36b713c4&scoped=true"
import script from "./shiftManagementMain.vue?vue&type=script&lang=js"
export * from "./shiftManagementMain.vue?vue&type=script&lang=js"
import style0 from "./shiftManagementMain.vue?vue&type=style&index=0&id=36b713c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b713c4",
  null
  
)

export default component.exports